// Generado desde design-system/components/core/Badge.tsx — no editar; edita el .ts/.tsx y corre build-ds.
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { cn } from '../../lib/cn';
const TONES = {
    neutral: { soft: 'bg-hair text-ink-2', solid: 'bg-ink text-ink-inverse', dot: 'bg-ink-3' },
    accent: { soft: 'bg-accent-soft text-accent-ink', solid: 'bg-accent text-[#03172C]', dot: 'bg-accent' },
    signal: { soft: 'bg-signal-soft text-signal-ink', solid: 'bg-signal text-[#2A1300]', dot: 'bg-signal' },
    pos: { soft: 'bg-pos-soft text-pos', solid: 'bg-pos text-ink-inverse', dot: 'bg-pos' },
    neg: { soft: 'bg-neg-soft text-neg', solid: 'bg-neg text-ink-inverse', dot: 'bg-neg' },
    warn: { soft: 'bg-warn-soft text-warn', solid: 'bg-status-warning text-[#2A1A00]', dot: 'bg-status-warning' },
};
/**
 * Badge — etiqueta de estado o categoría. tone: neutral | accent | signal | pos | neg | warn
 * Nunca transmite estado solo con color: lleva texto (y opcionalmente dot o ícono).
 */
export function Badge({ tone = 'neutral', variant = 'soft', dot = false, icon: Icon, className, children }) {
    const t = TONES[tone] ?? TONES.neutral;
    return (<span className={cn('inline-flex h-6 items-center gap-1.5 rounded-full px-2.5 text-caption font-semibold', variant === 'outline' ? 'border border-hair-2 text-ink-2' : t[variant], className)}>
      {dot && <span className={cn('h-1.5 w-1.5 rounded-full', t.dot)} aria-hidden="true"/>}
      {Icon && <Icon size={13} strokeWidth={2} aria-hidden="true"/>}
      {children}
    </span>);
}
const defaultFormat = (v) => `${v > 0 ? '+' : v < 0 ? '−' : ''}${Math.abs(v).toFixed(1)}%`;
/**
 * Delta — variación con flecha. El color depende del SIGNIFICADO, no del signo:
 * goodWhen="up" (ventas), "down" (costos), "none" (neutro: solo ink).
 * Precio de un competidor: "up" por defecto (sube = oportunidad, baja = amenaza).
 */
export function Delta({ value, format = defaultFormat, goodWhen = 'up', size = 'md', className }) {
    const dir = value > 0 ? 'up' : value < 0 ? 'down' : 'flat';
    const good = goodWhen === 'none' || dir === 'flat' ? null : dir === goodWhen;
    const Icon = dir === 'up' ? ArrowUpRight : dir === 'down' ? ArrowDownRight : Minus;
    const tone = good === null ? 'text-ink-2 bg-hair' : good ? 'text-pos bg-pos-soft' : 'text-neg bg-neg-soft';
    const label = dir === 'up' ? 'sube' : dir === 'down' ? 'baja' : 'sin cambio';
    return (<span className={cn('inline-flex items-center gap-0.5 rounded-full font-semibold tabular-nums', size === 'sm' ? 'h-5 px-1.5 text-caption' : 'h-6 px-2 text-body-sm', tone, className)}>
      <Icon size={size === 'sm' ? 12 : 14} strokeWidth={2.2} aria-hidden="true"/>
      <span className="sr-only">{label} </span>
      {format(value)}
    </span>);
}
